import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function AuthLogout() {
  const navigate = useNavigate()
  const { logout } = useAuth()

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await logout()
        navigate('/', { replace: true })
      } catch (error) {
        console.error('Logout error:', error)
        // Still redirect to home even if logout fails
        navigate('/', { replace: true })
      }
    }

    handleLogout()
  }, [logout, navigate])

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Signing you out...</h1>
          <p>Please wait while we sign you out</p>
        </div>
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  )
}

export default AuthLogout